import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=3c881262&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c881262')) {
      api.createRecord('3c881262', component.options)
    } else {
      api.reload('3c881262', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=3c881262&", function () {
      api.rerender('3c881262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JEOI2ILSftNn/JS/comp/currencymod.vue"
export default component.exports